import { TextButton } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const MobilePurchaseRootRequired = _ref => {
  let {
    domainName,
    action,
    datahook
  } = _ref;
  const {
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    main
  } = parseDomain(domainName ?? '');
  const {
    formattedInput
  } = parseDomain(main);
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.mobile.error.subdomain",
    values: {
      domainName: formattedInput
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: action
    })]
  }));
};
//# sourceMappingURL=MobilePurchaseRootRequired.js.map